import { get } from 'lodash';
import { DEFAULT_REDUX_KEY } from '../lib/dynamicStore/constants';
import { setGlobalErrorStatus } from '../global/actions';

export const hideError = () => {
  if (window[DEFAULT_REDUX_KEY]) {
    const store = window[DEFAULT_REDUX_KEY].getState();
    const error = get(store, ['global', 'globalData', 'error'], undefined);
    if (error) {
      window[DEFAULT_REDUX_KEY].dispatch(setGlobalErrorStatus({}));
    }
  }
};

const notifyError = () => {
  if (window[DEFAULT_REDUX_KEY]) {
    window[DEFAULT_REDUX_KEY].dispatch(setGlobalErrorStatus({ error: { code: 'genericError' } }));
  }
};

export default notifyError;
